"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeDefinition = exports.colors = void 0;
var muiColors = __importStar(require("@material-ui/core/colors"));
var styles_1 = require("../styles");
var common = muiColors.common, colors = __rest(muiColors, ["common"]);
exports.colors = colors;
exports.themeDefinition = {
    palette: {
        primary: {
            light: '#9b9b9b',
            main: '#003B5C',
            dark: '#000',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ddedfa',
            main: '#4FC3F7',
            dark: '#757575',
            contrastText: '#fff',
        },
        error: {
            light: '#9b9b9b',
            main: '#a6182d',
            dark: '#4a4a4a',
            contrastText: '#757575',
        },
        accent: {
            light: '#acd3d8',
            main: '#128192',
            dark: '#0c5a65',
            contrastText: '#fff',
        },
        color: colors,
    },
    overrides: {
        MuiIconButton: {
            root: {
                padding: 0,
            },
            colorInherit: {},
            colorPrimary: {},
            colorSecondary: {},
            disabled: {},
            label: {},
        },
        MuiTableRow: {
            hover: {
                backgroundColor: '#f5f5f5',
            },
            root: {
                '&$selected': {
                    backgroundColor: '#B3E5FC !important',
                },
            },
        },
        MuiCheckbox: {
            root: {
                '&$checked': {
                    color: '#4FC3F7',
                },
            },
        },
        MuiList: {
            dense: {
                paddingTop: 4,
                paddingBottom: 4,
            },
        },
    },
    props: {
        MuiFormControl: {
            margin: 'dense',
            variant: 'outlined',
        },
        MuiMenu: {
            getContentAnchorEl: null,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            MenuListProps: {
                dense: true,
            },
        },
        MuiSelect: {
            margin: 'dense',
            variant: 'outlined',
            MenuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
            },
        },
        MuiSnackbar: {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
        },
        MuiTextField: {
            margin: 'dense',
            variant: 'outlined',
        },
    },
};
/** @deprecated use theme definition instead and call `createTheme` wherever theme was originally referenced */
var theme = (0, styles_1.createTheme)(exports.themeDefinition);
exports.default = theme;
//# sourceMappingURL=calabrio.js.map